export const floatingButtons = {
  'floating-buttons.bag.title': 'View bag',
  'floating-buttons.scan-in-store.title': 'Scan in store',
};
